const { env } = window
const authConfig = {
  clientId: env.clientId,
  authorizationEndpoint: env.authUrl,
  tokenEndpoint: env.tokenUrl,
  redirectUri: env.redirectUrl,
  scope: env.scope,
  onRefreshTokenExpire: (event) => event.logIn(),
  decodeToken: true,
  autoLogin: false,
  preLogin: () => {
    const preLoginPath =
      window.location.pathname === '/'
        ? '/myprojects'
        : window.location.pathname
    localStorage.setItem('preLoginPath', preLoginPath)
  },
  postLogin: () => window.location.replace(localStorage.getItem('preLoginPath'))
}

export { authConfig }
